import { IRecipe } from "../../types/recipe";

export class RecipeDb {
  private dbName = "RecipeDB";
  private dbVersion = 2;
  private storeName = "recipe";

  async initDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve();
      };

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };
    });
  }

  async addRecipe(recipe: IRecipe, clear?: boolean): Promise<void> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    if (clear) {
      const clearRequest = store.clear();
      clearRequest.onsuccess = () => {
        console.log("cleared recipes");
      };
    }

    return new Promise((resolve, reject) => {
        store.put(recipe);

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  async addRecipes(recipes: IRecipe[], clear?: boolean): Promise<void> {
    const db = await this.getDB();

    // If clear is requested, clear first in a separate transaction
    if (clear) {
      await new Promise<void>((resolve, reject) => {
        const clearTransaction = db.transaction(this.storeName, "readwrite");
        const clearStore = clearTransaction.objectStore(this.storeName);
        const clearRequest = clearStore.clear();

        clearRequest.onsuccess = () => {
          console.log("cleared recipes");
        };

        clearTransaction.oncomplete = () => {
          resolve();
        };

        clearTransaction.onerror = () => {
          reject(clearTransaction.error);
        };
      });
    }

    // Now add the new recipes in a separate transaction
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    return new Promise((resolve, reject) => {
      recipes.forEach((recipe) => {
        store.put(recipe);
      });

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  async getRecipes(): Promise<IRecipe[]> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readonly");
    const store = transaction.objectStore(this.storeName);

    return new Promise((resolve, reject) => {
      const request = store.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  async updateRecipe(recipe: IRecipe): Promise<void> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    return new Promise((resolve, reject) => {
      const request = store.put(recipe);
      request.onsuccess = () => {
        console.log("recipe updated");
        console.log(recipe);
      };

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  private async getDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve(request.result);
      };
    });
  }
}
